import { render, staticRenderFns } from "./ManageDataSetDetails.vue?vue&type=template&id=1e85dfd4&"
import script from "./ManageDataSetDetails.vue?vue&type=script&lang=ts&"
export * from "./ManageDataSetDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports